export const claculatePurchaseData = (obj) => {
    const {balance, exchangeRate, userMax, minAllocation, userTotalPurchasedAmount, gasFees} = obj;

    const ableToPurchase = Math.min((balance - gasFees) / (exchangeRate / 100), userMax);

    const amountToCheck = (userTotalPurchasedAmount >= minAllocation ? 0 : minAllocation - userTotalPurchasedAmount)
    return {ableToPurchase, amountToCheck}
}